import React from 'react';
import BrandIcon, { BrandGradient } from './BrandIcon';

// Empty-state mark for Investor Updates: an envelope inside the
// gradient-bordered tile. See BrandIcon for the shared frame and the
// per-instance gradient ids.
const NoUpdatesIcon = (props) => {
  const uid = React.useId();
  const g = (n) => `no_updates_${uid}_${n}`;
  const paint = (id) => props.color ?? `url(#${id})`;

  return (
    <BrandIcon
      {...props}
      defs={
        <>
          <BrandGradient id={g(1)} x1="7" y1="31.75" x2="36.1916" y2="73.1832" />
          <BrandGradient id={g(2)} x1="10" y1="29.75" x2="19.863" y2="56.0514" />
        </>
      }
    >
      <rect
        x="19.25"
        y="25.25"
        width="41.5"
        height="28.5"
        rx="3.75"
        stroke={paint(g(1))}
        strokeWidth="2.5"
      />
      <path
        d="M20 26L40 41L60 26"
        stroke={paint(g(2))}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BrandIcon>
  );
};

export default NoUpdatesIcon;
